import React, { useContext, useEffect } from 'react';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import TicketsContainer from './sections/TicketsContainer';
import Header from '../common/Header';
import { useNetwork } from 'services/network';
import { Roles, backHomeLink, isTicketingActive } from 'utils/constants';
import { useTicketsStore } from '../store/ticketsStore';
import { FaqContainer, TicketsCart } from '../common';
import { useHistory } from 'react-router-dom';
import { InsidePageContainer, PageContainer } from '../common/style';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { LoaderCountContext } from 'context/LoaderV5';

const TicketsBuyHomePage = ({ locale, loggedUser }) => {
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const history = useHistory();
  const intl = useIntl();
  const i18nCommon = translations.TicketsV2(intl).Common;
  const i18n = translations.TicketsV2(intl).Buy;
  const isOperator = loggedUser.type === Roles.OPERATOR;
  const isPrd = !!loggedUser.isPrd;

  const { setLoaderActive } = useContext(LoaderCountContext);
  const showLoader = () => setLoaderActive(true);
  const hideLoader = () => setLoaderActive(false);
  const network = useNetwork();
  const { fetchedProducts, fetchedMerchandising, productsInCart } =
    useTicketsStore();

  useEffect(() => {
    const fetchData = async (params) => {
      showLoader();
      const {
        productData,
        merchData,
        // customerData,
      } = await network.aggregateTicketingLambda(params);
      if (productData && !productData?.error) {
        useTicketsStore.setState((prev) => ({
          ...prev,
          fetchedProducts: productData,
        }));
      } else {
        useTicketsStore.setState((prev) => ({
          ...prev,
          fetchedProducts: [],
        }));
      }
      // if (customerData?.accountid) setCustomer(customerData);
      if (merchData && !merchData?.error) {
        useTicketsStore.setState((prev) => ({
          ...prev,
          fetchedMerchandising: merchData,
        }));
      } else {
        useTicketsStore.setState((prev) => ({
          ...prev,
          fetchedMerchandising: [],
        }));
      }
      hideLoader();
    };
    const paymentId = new URLSearchParams(window.location.search).get(
      'payment_id'
    );
    const orderNumber = new URLSearchParams(window.location.search).get(
      'order_number'
    );
    if (paymentId && orderNumber) {
      history.push(
        `/checkout?payment_id=${paymentId}&order_number=${orderNumber}`
      );
    }
    const paymentCompleted = new URLSearchParams(window.location.search).get(
      'redirect_status'
    );

    if (paymentCompleted && paymentCompleted === 'succeeded' && orderNumber) {
      const path = window.location.pathname;
      window.location.href = `${backHomeLink}/${locale}${
        path?.includes('app') ? '/app' : ''
      }/sdm-tickets/success?order_number=${orderNumber}`;
    }
    if (loggedUser && loggedUser.type && isTicketingActive) {
      fetchData({
        loggedUserType: isOperator ? 'operator' : 'end_user',
        federationId: loggedUser?.salId,
        isPrd,
      });
    }
  }, []);

  const goToMerch = () =>
    history.push(fetchedMerchandising?.length ? '/merch' : '/assign-ticket');

  const isCartOpen =
    productsInCart?.length &&
    productsInCart?.some((pro) => pro.quantity && pro.quantity > 0);
  const isApp = isCartOpen && window.location.pathname.includes('app');

  return (
    loggedUser && (
      <>
        {new URLSearchParams(window.location.search).get(
          'order_number'
        ) ? null : (
          <PageContainer direction={'column'} forcePaddingBottom={isApp}>
            <InsidePageContainer>
              <Header loggedUser={loggedUser} hideBack={true} />
              <Stack direction={isLgDown ? 'column' : 'row'}>
                {fetchedProducts && fetchedProducts?.length ? (
                  <TicketsContainer
                    fetchedProducts={fetchedProducts}
                    locale={locale}
                    loggedUser={loggedUser}
                  />
                ) : (
                  <Stack
                    style={{
                      width: isLgDown ? '100%' : '64%',
                      ...(!isLgDown && {
                        paddingRight: '70px',
                      }),
                    }}
                    gap={'25px'}
                  ></Stack>
                )}
                {isCartOpen ? (
                  <TicketsCart
                    locale={locale}
                    procideFn={goToMerch}
                    procideMsg={i18nCommon.proceedMsg}
                  />
                ) : null}
              </Stack>
              <FaqContainer
                faqs={{
                  ...i18n,
                  faqList: isOperator
                    ? [
                        i18n.operatorFaqItem,
                        i18n.GenevaFaqItem,

                        ...i18n.faqList,
                      ]
                    : i18n.faqList,
                }}
              />
            </InsidePageContainer>
          </PageContainer>
        )}
      </>
    )
  );
};
export default TicketsBuyHomePage;
